import React from "react";
import { ColPrompt, DebounceForText, SpecSelectWrapper } from ".";
import { Container, Table, Row, Col } from "reactstrap";
import { AttachmentManager } from "../";
import { constants, dateHelpers } from "../../utils";
import { useSpecificationContextState } from "./useSpecificationContextState";
import _ from "lodash";

export default function TabAdditionalInfo() {
  const SpecContextState = useSpecificationContextState();
  const AttachmentKey = _.trim(SpecContextState.specification.itemNumber);

  return (
    <Container fluid className="px-2 py-4">
      <Row className="text-white">
        <Col className="px-4">
          <AttachmentManager
            AttachmentMutedText={"text-white"}
            attachmentTypeId={constants.ATTACHMENT_TYPES.Item}
            attachmentKey={AttachmentKey}
            contextName={AttachmentKey}
          />
        </Col>
      </Row>
      <>
        <Row className="qualitySpecificationEditRow">
          <ColPrompt title={"Suggested Needle Size"} />
          <SpecSelectWrapper
            onChangeString={"needleSize"}
            optionsPRP={SpecContextState.needleSizeOptions}
          />
        </Row>
        <Row className="qualitySpecificationEditRow">
          <ColPrompt title={"Special Instructions"} />
          <DebounceForText
            valuePRP={SpecContextState.specification.instructions}
            onChangeString={"instructions"}
            elementPRP={"textarea"}
            maxLengthPRP={1000}
          />
        </Row>
        <Row className="qualitySpecificationEditRow">
          <ColPrompt title={"Quality Revision History"} headerPRP />
        </Row>
        <Row className="qualitySpecificationEditRow">
          <Col className="px-4 py-2">
            <Table size="sm" className="data-table">
              <thead className="table-header">
                <tr>
                  <th>NUM</th>
                  <th style={{width: "100px"}}>DATE</th>
                  <th>NOTE</th>
                </tr>
              </thead>
              <tbody>
                {_.map(
                  SpecContextState.specification.revisionNotes,
                  (x, indx) => {
                    return (
                      <tr
                        key={`revNote${indx}${x.revNumber}`}
                        className={`tr-${
                          indx % 2 === 0 ? "primary" : "secondary"
                        }`}
                      >
                        <td>{x.revNumber}</td>
                        <td>{dateHelpers.shortDateTimeFormat(x.revDate)}</td>
                        <td>{x.revDescription}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </>
    </Container>
  );
}
